import { createFeature } from '@ngrx/store';

import { templateReducer } from './template.reducer';

export const templateFeatureKey = 'template';

export const templateFeature = createFeature({
  name: templateFeatureKey,
  reducer: templateReducer,
});
